
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCellBad as ObiCellBadElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cell-bad.js';
 
 
 

 
 export const ObiCellBad = createComponent({
   react: React,
   tagName: 'obi-cell-bad',
   elementClass: ObiCellBadElement,
   events: {
     
   }
  });
 
 